export const environment = {
  production: false,
  raygunApiKey: "F9TwIW4t88FA9FwegywHQ",
  apiUrl: "https://lgtapi-beta.agilx.com/api/",
  filesUrl: "https://lgtapi-beta.agilx.com/api/",
  url: "https://lgt-beta.agilx.com/",
  urlClient: "https://lgt-beta.agilx.com/",
  googleMapsApiKey: "AIzaSyBqSQGcjeP3kqGyhT5LLqgDWnr2Xrz0LOU",
};
